/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AdditionalResourceDetailsForFinopsUtilizationAzureAdvisor extends models.AdditionalResourceDetailsForFinopsReservationRecommendations {
    constructor() {
        super();
        this.setDiscriminator("AdditionalResourceDetailsForFinopsUtilizationAzureAdvisor");
    }

    getFixupPrototypeFunction() { return AdditionalResourceDetailsForFinopsUtilizationAzureAdvisor.fixupPrototype; }

    static newInstance(model: Partial<AdditionalResourceDetailsForFinopsUtilizationAzureAdvisor>): AdditionalResourceDetailsForFinopsUtilizationAzureAdvisor {
        let obj = Object.assign(new AdditionalResourceDetailsForFinopsUtilizationAzureAdvisor(), model);
        AdditionalResourceDetailsForFinopsUtilizationAzureAdvisor.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AdditionalResourceDetailsForFinopsUtilizationAzureAdvisor>): AdditionalResourceDetailsForFinopsUtilizationAzureAdvisor {
        if (!model) return null;
        return AdditionalResourceDetailsForFinopsUtilizationAzureAdvisor.newInstance(<AdditionalResourceDetailsForFinopsUtilizationAzureAdvisor> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AdditionalResourceDetailsForFinopsUtilizationAzureAdvisor) {
        if (!obj) return;

        models.AdditionalResourceDetailsForFinopsUtilizationAzureAdvisor.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AdditionalResourceDetailsForFinopsUtilizationAzureAdvisor): boolean {
        if (models.AdditionalResourceDetailsForFinopsReservationRecommendations.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AdditionalResourceDetailsForFinopsUtilizationAzureAdvisor.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
